export default {
  maxTabletSize: 1080,
  maxPhoneSize: 900 + 1,
  maxSmallPhoneSize: 375,
}
